import { getReportParams, report } from '../../../../middleware/report';
import {
} from '../Constant/Constant';

export const DWHStatus = {
  Ongoing: 'Ongoing',
  Completed: 'Completed',
  Error: 'Error',
}

export const DwhActionType = {
  SelectServicePage: 'Select Service Page',
  SelectLineAddressPage: 'Select Line/Address Page',
  SelectServicePage: 'Select Service Page',
  NewOwnerDetailPage: 'New Owner Detail Page',
  SuccessScreen: 'Success Screen'

}

export const selectedProductType = {
  Cellular: 'נייד',
  Internet: 'אינטרנט',
  TV: 'TV',
  Bundle: ''
}

export const DWHMessageText = {
  SelectServicePageDisplayed: 'Select Service Page Displayed',
  SelectLineAddressPageDisplayed: 'Select Line/Address Page Displayed',
  SelectServicePageButtonClicked: 'Select Service Page Button Clicked',
  SelectLineAddressPageButtonClicked: 'Select Line/Address Page Button Clicked',
  ErrorOpenOrderDisplayed: 'Error Open Order Displayed',
  ErrorUserBNIYODDisplayed: 'Error User BNIYOD Displayed',
  ErrorUserisabroadDisplayed: 'Error User is abroad Displayed',
  ErroreSIMDisplayed: 'Error eSIM Displayed',
  ErrorUserpostponedDisplayed: 'Error User postponed Displayed',
  ErrorDataUserDisplayed: 'Error Data User Displayed',
  ErrorBusinessUserDisplayed: 'Error Business User Displayed',
  ErrorAbroadPackageDisplayed: 'Error Abroad Package Displayed',
  PopupEquipmentRepairDisplayed: 'Popup Equipment Repair Displayed',
  ErrorDebtDisplayed: 'Error Debt Displayed',
  NewOwnerDetailPageDisplayed: 'New Owner Detail Page Displayed',
  NewOwnerDetailPageButtonClicked: 'New Owner Detail Page Button Clicked',
  BlacklistError: 'Blacklist Error',
  SuccessScreen: 'Success Screen',
  GeneralError: 'General Error ',
}



export function dwhGeneralReport({ data, actionType, messageText, status }) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'OwnershipTransfer - seller';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = actionType;
  reportParams.status = status;
  reportParams.messageText = messageText;
  reportParams.param1 = data.selectedServiceType == 'Cellular' ? 'נייד' : data.serviceToTransfer?.packageName;
  reportParams.param2 = data.selectedServiceType == 'Cellular' ? data.serviceToTransfer?.subscriberNumber : data.serviceToTransfer?.customerAddress;
  reportParams.param3 = data.serviceToTransfer?.assetExternalId || '';
  reportParams.param9 = data.userDetails.IsContactPerson ? 'איש קשר' : 'מנוי';
  reportParams.param10 = 'לקוח';
  reportParams.idNumber = data.userDetails?.IDNumber;
  reportParams.customerName = `${data.userDetails?.firstName} ${data.userDetails?.lastName}`;
  reportParams.subscriber = data.userDetails?.contactNumber;
  reportParams.ban = data.serviceToTransfer?.ban || '';
  reportParams.sourceURL = window.location.href;
  report(reportParams);
}
